import type { Cancelable, Response } from './types';

export enum ContentType {
  JSON = 'application/json',
  FORM_URLENCODED = 'application/x-www-form-urlencoded',
  MULTIPART_FORM_DATA = 'multipart/form-data',
}
export interface Client {
  // GET methods
  get<T>(path: string, data?: unknown): Promise<Response<T>>;
  // POST methods
  post<T>(
    path: string,
    data?: unknown,
    contentType?: ContentType,
    options?: unknown,
    cancelRequest?: (abortController: AbortController) => void
  ): Promise<Response<T> & Cancelable>;
  // PATCH methods
  patch<T>(path: string, data: URLSearchParams): Promise<Response<T>>;
  // DELETE methods
  delete<T>(path: string): Promise<Response<T>>;
}
